<script>
	import CustomInput from "../../../components/CustomInput/CustomInput.svelte";
	import { Col, Row } from "@sveltestrap/sveltestrap";
	import { jobStatusFilter } from "src/utils/options";
	import LimitSize from "../../../components/SizeSelect/limitSize.svelte";
	import CustomButton from "../../../components/CustomButton/CustomButton.svelte";
	import { debounce } from "lodash";
	import CustomDatePicker from "../../../components/CustomDatePicker/CustomDatePicker.svelte";
	import DropdownCheckbox from "../../../components/DropdownCheckbox/DropdownCheckbox.svelte";
	import { lookupToOptions } from "../../../utils/misc";
	import { navigate } from "svelte-routing";
	import queryString from "query-string";
	import { initPage } from "src/store/store";

	export let changeSearchParams = () => {};
	export let params;
	export let lookups;
	export let jobLookups;
	export let jobStatus;

	const debouncedInput = debounce((e) => handleChange(e), 1000);

	let plateNo = "";
	let assignedUserMobileNo = "";
	let isOpen = -1;
	let startDate = "";
	let endDate = "";

	function toggleDropdown(idx) {
		isOpen = isOpen === idx ? -1 : idx;
	}

	async function handleChange(value) {
		changeSearchParams({ ...value, pageNumber: 1, page: 1 });
	}

	function resetFilter() {
		let tab = queryString.parse(location.search).tab || 1;
		initPage.set(1);
		navigate("/jobs" + `?tab=${tab}`);
		changeSearchParams("");
	}

	$: options = {
		categoryIds: lookupToOptions(lookups.presetTasks) || [],
		statuses: lookupToOptions(jobStatus) || [],
		estateIds: lookupToOptions(jobLookups.estateLookups) || [],
		regionIds: lookupToOptions(lookups.regions) || [],
	};

	$: if (params.categoryIds) {
		options.categoryIds = options.categoryIds.map((category) => ({
			...category,
			selected: params.categoryIds.includes(category.id),
		}));
	} else {
		// clear all selections if no params
		options.categoryIds = options.categoryIds.map((category) => ({
			...category,
			selected: false,
		}));
	}

	$: if (params.regionIds) {
		options.regionIds = options.regionIds.map((region) => ({
			...region,
			selected: params.regionIds.includes(region.id),
		}));
	} else {
		options.regionIds = options.regionIds.map((region) => ({
			...region,
			selected: false,
		}));
	}

	$: if (params.estateIds) {
		options.estateIds = options.estateIds.map((estate) => ({
			...estate,
			selected: params.estateIds.includes(estate.id),
		}));
	} else {
		options.estateIds = options.estateIds.map((estate) => ({
			...estate,
			selected: false,
		}));
	}

	$: if (params.statuses) {
		options.statuses = options.statuses.map((status) => ({
			...status,
			selected: params.statuses.includes(status.id),
		}));
	} else {
		options.statuses = options.statuses.map((status) => ({
			...status,
			selected: false,
		}));
	}

	$: if (params.plateNo) {
		plateNo = params.plateNo;
	} else {
		plateNo = "";
	}

	$: if (params.assignedUserMobileNo) {
		assignedUserMobileNo = params.assignedUserMobileNo;
	} else {
		assignedUserMobileNo = "";
	}

	$: if (params.startDate) {
		startDate = params.startDate;
	} else {
		startDate = "";
	}

	$: if (params.endDate) {
		endDate = params.endDate;
	} else {
		endDate = "";
	}
</script>

<Row>
	<Col xs={12}>
		<Row>
			<Col xs={10}>
				<Row>
					<Col xs={3}>
						<CustomInput
							placeholder="Vehicle no."
							search
							bind:value={plateNo}
							onInput={(e) =>
								debouncedInput({
									[e.target.name]: e.target.value,
								})}
							name="plateNo"
						/>
					</Col>
					<Col xs={3}>
						<CustomInput
							placeholder="Mobile no."
							search
							bind:value={assignedUserMobileNo}
							onInput={(e) =>
								debouncedInput({
									[e.target.name]: e.target.value,
								})}
							name="assignedUserMobileNo"
						/>
					</Col>
					<Col xs={4}>
						<CustomDatePicker
							onChange={(e) => {
								handleChange({
									startDate: e.detail[0],
									endDate: e.detail[1],
								});
								startDate = e.detail[0];
								endDate = e.detail[1];
							}}
							name="dateRange"
							isRange={true}
							placeholder={"Select a date range"}
							value={startDate && endDate
								? [startDate, endDate]
								: ""}
						/>
					</Col>
				</Row>
			</Col>
			<Col xs={2} style="position:relative">
				<Row>
					<Col class="d-flex justify-content-end">
						<LimitSize />
					</Col>
				</Row>
				<Row>
					<Col
						class="d-flex justify-content-end"
						style="position:absolute"
					>
						<!-- DONT FORGET TO CHANGE TO REAL DATE FROM BE -->
						<span
							class="on-surface-variant"
							style="text-align: end; white-space: nowrap"
							>Last updated {"Jul 30, 9:00 AM"}</span
						>
					</Col>
				</Row>
			</Col>
		</Row>
		<Row>
			<Col xs={11}>
				<Row class="mb-3">
					<Col xs={2}>
						<DropdownCheckbox
							categoryName="Tasks"
							options={options.categoryIds}
							id="categoryIds"
							refetch={handleChange}
							isOpen={isOpen === 1}
							toggle={() => toggleDropdown(1)}
						/>
					</Col>
					<Col xs={2}>
						<DropdownCheckbox
							categoryName="Statuses"
							options={options.statuses}
							id="statuses"
							refetch={handleChange}
							isOpen={isOpen === 2}
							toggle={() => toggleDropdown(2)}
						/>
					</Col>
					<Col xs={2}>
						<DropdownCheckbox
							categoryName="Region"
							options={options.regionIds}
							id="regionIds"
							refetch={handleChange}
							isOpen={isOpen === 3}
							toggle={() => toggleDropdown(3)}
						/>
					</Col>

					<Col xs={2}>
						<DropdownCheckbox
							categoryName="Estate"
							options={[...options.estateIds].sort((a, b) =>
								a.label.localeCompare(b.label)
							)}
							id="estateIds"
							refetch={handleChange}
							isOpen={isOpen === 4}
							toggle={() => toggleDropdown(4)}
						/>
					</Col>
					<Col class="d-flex align-items-center">
						<CustomButton
							style="border-color: transparent; font-weight: bold"
							buttonText="Clear filters"
							on:click={resetFilter}
						/>
					</Col>
				</Row>
			</Col>
		</Row>
	</Col>
</Row>
